






















import { snakeCase } from 'lodash'
import { Component, Emit } from 'vue-property-decorator'

import WindowResizeMixin from '../../../../../../../../../../logic/helpers/WindowResizeMixin'
import { ActionTypes } from '../../../logic/Actions/types'
import { getActionNodeActionsIcons } from '../../../logic/utils'

@Component({
  data() {
    return {
      snakeCase,
      ActionTypes,
      getActionNodeActionsIcons,
    }
  }
})
export default class AddingAction extends WindowResizeMixin {
  @Emit()
  addAction(type: ActionTypes): ActionTypes {
    return type
  }
}
